import { render, staticRenderFns } from "./pop_preview_enSentence.vue?vue&type=template&id=70bf1246&scoped=true&"
import script from "./pop_preview_enSentence.vue?vue&type=script&lang=js&"
export * from "./pop_preview_enSentence.vue?vue&type=script&lang=js&"
import style0 from "./pop_preview_enSentence.vue?vue&type=style&index=0&id=70bf1246&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bf1246",
  null
  
)

export default component.exports